import React, { useRef } from 'react';
import { Menu } from 'antd';
import Icon, {
  ApiOutlined,
  BellOutlined,
  LinkOutlined,
  MenuOutlined,
  SettingOutlined,
  WhatsAppOutlined,
} from '@ant-design/icons';

import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';

import './style.less';

import useWindowSize from '../../../hooks/windowSize';
import useHorizontalScroll from '../../../hooks/useHorizontalScroll';

const { Item } = Menu;

const FormSettingsMenu = ({ isLoading, handleMenuChange, screen, form }) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  function handleMenuSelect(e) {
    handleMenuChange(e.key);
  }
  const isStillGoogleForm = form && form.formId && !form.from;

  const menuRef = useRef();
  const windowSize = useWindowSize();
  const [hasLeftScroll, hasRightScroll] = useHorizontalScroll(menuRef, windowSize);

  return (
    <div className="form-settings-menu-container" ref={menuRef}>
      <Menu
        onSelect={handleMenuSelect}
        selectedKeys={[screen]}
        className="form-settings-menu"
        selectable={!isLoading}
        mode={'vertical'}
      >
        <Item key="general" icon={<SettingOutlined />}>
          {t('formSettings.general')}
        </Item>

        <Item key="notifications" icon={<BellOutlined />}>
          {t('formSettings.notifications')}
        </Item>

        <Item key="seo" icon={<LinkOutlined />}>
          SEO
        </Item>

        {form && !isStillGoogleForm && (
          <Item key="team" icon={<WhatsAppOutlined />}>
            {t('formSettings.team')}
          </Item>
        )}
        {form && !isStillGoogleForm && (
          <Item key="integrations" icon={<ApiOutlined />}>
            {t('integrations')}
          </Item>
        )}
      </Menu>
      {isMobile && hasRightScroll ? <div className="menu-scroll-indicator right"></div> : null}
      {isMobile && hasLeftScroll ? <div className="menu-scroll-indicator left"></div> : null}
    </div>
  );
};

export default FormSettingsMenu;
